import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MainPage from './pages/MainPage';
import MyPage from './pages/MyPage';
import ProductListPage from './pages/ProductListPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProductCreatePage from './pages/ProductCreatePage';
import CartPage from './pages/CartPage';
import OrderPage from './pages/OrderPage';
import OrderListPage from './pages/OrderListPage';
import OrderDetailPage from './pages/OrderDetailPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailPage from './pages/PaymentFailPage';
import AdminPage from './pages/AdminPage';
import {CartProvider} from './context/CartContext';
import BoardListPage from './pages/BoardListPage';
import BoardDetailPage from './pages/BoardDetailPage';
import EventListPage from './pages/EventListPage';
import EventDetailPage from './pages/EventDetailPage';
import BoardWritePage from './pages/BoardWritePage';
import BoardEditPage from './pages/BoardEditPage';
import WishlistPage from './pages/WishlistPage';
import RecentProductsPage from './pages/RecentProductsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import Footer from './components/Footer';
import CartSidebar from './components/CartSidebar';
import { ModalProvider } from './context/ModalContext';
import NotFoundPage from './pages/NotFoundPage';
import LoadingBar from './components/LoadingBar'; 
import PrivacyPage from './pages/Privacypage';
import TermsPage from './pages/TermsPage';

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <ModalProvider>
          <LoadingBar />
          <Header />
          <CartSidebar />
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/products" element={<ProductListPage />} />
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/products/create" element={<ProductCreatePage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/orders" element={<OrderListPage />} />
            <Route path="/orders/:orderId" element={<OrderDetailPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/fail" element={<PaymentFailPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/boards" element={<BoardListPage />} />
            <Route path="/boards/write" element={<BoardWritePage />} />
            <Route path="/boards/edit/:boardId" element={<BoardEditPage />} />
            <Route path="/boards/:boardId" element={<BoardDetailPage />} />
            <Route path="/events" element={<EventListPage />} />
            <Route path="/events/:eventId" element={<EventDetailPage />} />
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/recent" element={<RecentProductsPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
          <Footer />
        </ModalProvider>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;